'use strict';

import { find, orderBy } from 'lodash';

export function lookup(staticData, type, criteria, field) {
  const data = staticData[type];
  const match = find(data, criteria);
  return match ? (match[field] || match.name || match.primaryText) : null;
}

export function getLookupValue(staticData, type, criteria) {
  return find(staticData[type] || [], criteria);
}

export function statusGroupOrDefault(group, statusGroups) {
  return (group) ? group : ((statusGroups || []).sort((a, b) => a.id - b.id)[0] || {name: 'In Process'}).name;
}

export function convertToMenuItems(lookups, valueProp = 'id', textProp = 'name', subElementProp) {
  return lookups.map((item, index) => ({
    value: item[valueProp],
    primaryText: item[textProp],
    subElement: item[subElementProp]
  }));
}

export function convertContactsToMenuItems(contacts = []) {
  return contacts.map((contact) => {
    return {
      name: `${contact.user.firstName} ${contact.user.lastName}`,
      value: contact.profile.id,
    };
  });
}

export function convertEmployeeToMenuItems(employees = []) {
  return employees.map((employee) => {
    return {
      name: `${employee.firstName} ${employee.lastName}`,
      value: employee.employeeId,
    };
  });
}

export function skillCategoryTypesByTenant(accountId = 0, skillCategoryTypes = [], show = 'showInBoth') {
  return skillCategoryTypes.filter((cat) => {
    return SKILL_AVAILABILITY_ID[show].includes(cat.skillAvailabilityId) && cat.hide === false;
  });
}

export const SKILL_AVAILABILITY_ID = {
  showInApplication: [null, 1, 3],
  showInJobRequest: [null, 2, 3],
  showInBoth: [null, 3],
  showInNone: [],
};

export const APPLICANT_STATUS = {
  NEW_APPLICANT: 1,
  PENDING_PRELIMINARY_INTERVIEW: 2,
  PENDING_APPLICATION: 3,
  PENDING_ASSESSMENTS: 4,
  PENDING_APPLICATION_INTERVIEW: 5,
  PENDING_INFORMATION_UPDATE: 6,
  UNRESPONSIVE: 7,
  NOT_QUALIFIED: 8,
  NOT_INTERESTED: 9,
  IN_WAITING: 10,
  QUALIFIED_CANDIDATE: 11,
  READY_TO_PLACE: 12,
  PENDING_REFERENCE_CHECKS: 13,
  ARCHIVED: 14,
  DNC: 15,
  UNAVAILABLE: 16,
  PENDING_REVIEW: 17,
  QUALIFIED_IN_WAITING: 18,
  QUALIFIED_CANDIDATE_IN_QUEUE: 19,
  ACTIVE: 20,
  PLACED: 21,
  UNRESPONSIVE_BH: 22,
  UNAVAILABLE_BH: 23,
  FULLY_RETIRED: 24,
  DIRECT_HIRE: 25,
  NOT_QUALIFIED_BH: 26,
  NOT_INTERESTED_BH: 27
};

export const CONTACT_ROLES = {
  BILLING: 1,
  EXECUTIVE: 2,
  HR: 3,
  KEY: 4,
  MAIN: 5,
  MANAGER: 6,
  OWNER: 7,
  REPORTING: 8,
  SUPERVISOR: 9,
  TECHNOLOGY: 10,
  TRAINING: 11,
  SOCIAL_MEDIA: 12,
  NEWSLETTER: 13,
  MARKETING: 14,
  EDITOR: 15
};

export const JOB_REQUEST_STATUS = {
  IN_PROCESS: 1,
  NEW_REQUEST: 2,
  NA: 3,
  APPROVED_REQUEST: 4,
  CANDIDATE_PLACED: 5
};

export const SEGMENT_TYPES = {
  HEALTH_BENEFITS: 1,
  LIFE_PRODUCTS: 2,
  COMMERCIAL_LINES: 3,
  PERSONAL_LINES: 4,
  FINANCIAL_PLANNING: 6,
  OTHER: 7
};

export const JOB_REQUEST_SEGMENT_TYPES = {
  COMPANY_WIDE: 1,
  HEALTH_BENEFITS: 2,
  LIFE_PRODUCTS: 3,
  COMMERCIAL_LINES: 4,
  PERSONAL_LINES: 5,
  COMMERCIAL_PERSONAL_SPLIT: 6,
  FINANCIAL_PLANNING: 7,
  OTHER: 8
};



// WEBPACK FOOTER //
// ./shared/redux/helpers/staticData.js